// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"533ec3f1","72":"08e53c68","81":"f9c5eae4","108":"2d10f6ea","250":"31bcca38","256":"020c2858","397":"9918269e","488":"ab50500c","737":"2519d7be","743":"47addb41","791":"cb6fc413"}[chunkId] + ".chunk.js";
};